import { useEffect, useState, useCallback } from "react";
import {
  getShowUnavailable,
  setShowUnavailable,
  SHOW_UNAVAILABLE_EVENT,
} from "services/gameAvailability";

/**
 * Reactive "Show unavailable games" state, shared by every mounted grid/slider.
 * Writing through the returned setter persists to sessionStorage and broadcasts
 * SHOW_UNAVAILABLE_EVENT, so sibling grids re-render without a remount — the
 * same pattern as useCountryRefetch's COUNTRY_CHANGED_EVENT subscription.
 */
export default function useShowUnavailable() {
  const [show, setShow] = useState(getShowUnavailable);

  useEffect(() => {
    const onChange = () => setShow(getShowUnavailable());
    window.addEventListener(SHOW_UNAVAILABLE_EVENT, onChange);
    return () => window.removeEventListener(SHOW_UNAVAILABLE_EVENT, onChange);
  }, []);

  const update = useCallback((value) => {
    setShowUnavailable(value);
  }, []);

  return [show, update];
}
